export function getPageTypeForBi(itemType, isCrossPage) {
  if (isCrossPage === void 0) {
    isCrossPage = false;
  }
  if (!itemType) {
    return '';
  }
  const trimmed = itemType.trim();
  if (trimmed === '') {
    return '';
  }
  const normalized = trimmed.toLowerCase();
  return isCrossPage ? `cross_${normalized}_page` : normalized;
}
//# sourceMappingURL=bi-helpers.js.map